import React, { } from 'react';
import s from './BeauPic.scss';
import { LinkWrapper } from '../../../components/BaseComp';
import { isFeedInstance, FeedInstance } from '../../../models/feed';
import { genRands, genPCMCode } from '../../../utils/spmHelper';
import { isBaiduUnionPromotionInstance, isPromotionInstance, PromotionInstance } from '../../../models/apis/promotion';

const FirstFeed = ({ data }: { data: any }) => {
    if (isFeedInstance(data)) {
        return (
            <div className={s.first}>
                <LinkWrapper href={data.url} data-spm-strict="true">
                    <div className="scale">
                        <img src={((data.bigCover || data.images[0] || '').replace(/w_([\s\S]+?),/g, 'w_960,').replace(/h_([\s\S]+?),/g, 'h_640,'))} />
                    </div>
                    <div className={s.titleWrapper}>
                        <p className={s.feedTitle}>{data.title}</p>
                    </div>
                </LinkWrapper>
            </div>
        );
    }
    return (
        <div className={s.first} />
    )
}

interface Props {
    dataSources: Array<Array<FeedInstance | PromotionInstance>>,
    spms: string[],
}

export const BeauPic = (props: Props) => {

    const { dataSources, spms } = props;

    // new Slider({
    //     node: document.querySelector(`#${randomID}`),
    //     width: 1128,
    //     loop: true,
    //     interval: 10000,
    //     mode: 'opacity'
    // });

    const placeHolders: FeedInstance[][] = [];
    const placeHoldersFlag: number[] = [];
    const active = 0;
    dataSources.forEach((source, index) => {
        placeHolders[index] = (source.filter(e => !isPromotionInstance(e)) as FeedInstance[]).slice(-2);
        placeHoldersFlag[index] = 0;
    })

    return (
        <div className={s.container}>
            <div data-asm-new-slider="true" className="slider">
                <div className="slider-wrapper">
                    {dataSources.map((arr, i) => {
                        return (
                            <div className={["beau-pic-item slider-item",i === active ? 'active' : ''].join(' ')} key={i} data-spm={spms[i]}>
                                <FirstFeed data={arr && arr && arr[0]} />
                                <div className={s.right}>
                                    {arr.slice(1, 7).map((item, index) => {
                                        if (isFeedInstance(item)) {
                                            let imgUrl = item.cover || item.images[0] || '';
                                            imgUrl = imgUrl.replace(/w_([\s\S]+?),/g, 'w_440,').replace(/h_([\s\S]+?),/g, 'h_260,');
                                            return (
                                                <div key={item.title} className={s.item}>
                                                    <LinkWrapper href={`${item.url}?scm=${item.scm}`} key={index} data-spm-strict="true">
                                                        <div className="scale">
                                                            <img src={imgUrl} />
                                                        </div>
                                                        <div className={s.titleWrapper}>
                                                            <p className={s.feedTitle}>{item.title}</p>
                                                        </div>
                                                    </LinkWrapper>
                                                </div>
                                            )
                                        } else if (isBaiduUnionPromotionInstance(item)) {
                                            const width=220,height=184,overflow='hidden',display="inline-block";
                                            return (
                                                <div className={s.item} data-spm-strict="true" style={{display}} data-spm-type="resource" data-spm-content={genPCMCode(item)}>
                                                    <div className="overflowHidden"
                                                        key={index} 
                                                        data-w="220px" 
                                                        data-h="184px"
                                                        style={{ width, height,overflow}}
                                                        data-genRands={genRands()}
                                                        data-baidu-id={item.adData.id}
                                                    >
                                                    </div>
                                                    {/* <iframe key={index} src={`//assp.sohu.com/page?baid=${item.adData.id}&aty=BAIDUUNION&child=${genRands()}`} width="220" height="184" frameBorder={'0'}></iframe> */}
                                                </div>
                                            )
                                        }
                                        return null;
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/HomeTop/BeauPic/index.tsx